var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CompForm',{ref:"comp_form",attrs:{"value":_vm.formdata,"forms":_vm.forms,"data-watch":_vm.watch_form,"param":_vm.param,"config":_vm.formConfig},on:{"on-submit":_vm.onSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }